import { createI18n } from 'vue-i18n';

import { resolveBrowserLocale } from './resolveBrowserLocale';

import projectLocales from '@/locales';

export const i18n = createI18n({
  locale: typeof navigator !== 'undefined'
    ? resolveBrowserLocale(navigator.language)
    : 'en',
  fallbackLocale: 'en',
  messages: projectLocales,
  globalInjection: true, // Injects $t in all the app templates
});
